var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyoptions2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 29.2,
    height: 14,
    viewBox: "0 0 29.2 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final-Copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2 0H7C3.1 0 0 3.1 0 7C0 10.9 3.1 14 7 14H22.2C26.1 14 29.2 10.9 29.2 7C29.2 3.1 26 0 22.2 0ZM1.2 7C1.2 3.8 3.8 1.2 7 1.2H16.9L13.8 12.8H7C3.8 12.8 1.2 10.2 1.2 7Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x",
    d: "M24.2 4C24.4 4.2 24.4 4.6 24.2 4.8L22.1 7L24.3 9.2C24.5 9.4 24.5 9.8 24.3 10C24.1 10.2 23.7 10.2 23.5 10L21.3 7.8L19.1 10C18.9 10.2 18.5 10.2 18.3 10C18.1 9.8 18.1 9.4 18.3 9.2L20.4 7L18.2 4.8C18 4.6 18 4.2 18.2 4C18.4 3.8 18.8 3.8 19 4L21.2 6.2L23.4 4C23.6 3.8 24 3.8 24.2 4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    d: "M12.3 4.1C12.5 4.3 12.6 4.7 12.4 4.9L8.2 9.8C8.1 9.9 8 10 7.9 10C7.7 10.1 7.4 10.1 7.2 9.9L5 7.7C4.8 7.5 4.8 7.1 5 6.9C5.2 6.7 5.6 6.7 5.8 6.9L7.6 8.6L11.4 4.1C11.6 3.9 12 3.9 12.3 4.1Z",
    fill: "#0066FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyoptions2);
export default __webpack_public_path__ + "static/media/privacyoptions-2.f9c6e886d86fc1f654fcf44039ddbf01.svg";
export { ForwardRef as ReactComponent };